/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useState } from 'react';
import classNames from 'classnames';
import { WhiteLogo } from '@/assets/logos/';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownField } from '@/components';
import { ConfirmDialog } from 'primereact/confirmdialog';

import {
  faCircleUser,
  faGear,
  faSignOut,
} from '@fortawesome/free-solid-svg-icons';
import { isAuthenticated } from '@/utils/auth';
import { useTranslation } from 'react-i18next';
import { PagesPaths } from '@/enums';
import { OptionType } from '@/components/DropdownField/DropdownField';
import { useAuthContext } from '@/hooks';

import styles from './Header.module.scss';

import './Header.scss';

type HeaderProps = {
  isPrivate?: boolean;
};

export const optionTemplate = (option: OptionType) => {
  return (
    <div
      className={classNames(
        styles.option,
        option.color === 'danger' ? styles.danger : styles.main
      )}
    >
      <FontAwesomeIcon icon={option.icon} className={styles.icon} />
      <span className={styles.label}>{option.name}</span>
    </div>
  );
};

const Header: FC<HeaderProps> = ({ isPrivate }) => {
  const { t } = useTranslation(['header', 'profilePage', 'signUp']);
  const { onLogout, userDataDecoded } = useAuthContext();
  const navigate = useNavigate();
  const [confirmLogOut, setConfirmLogOut] = useState(false);

  const accept = () => {
    onLogout();
    setConfirmLogOut(false);
  };

  const reject = () => {
    setConfirmLogOut(false);
  };

  const options = [
    {
      name: t('profilePage:config'),
      value: 'config',
      icon: faGear,
      color: 'main',
    },
    {
      name: t('profilePage:signOut'),
      value: 'signOut',
      icon: faSignOut,
      color: 'danger',
    },
  ];

  const handleDropdownChange = (e: { value: string | null }, name: string) => {
    if (e.value === 'config' && name === 'userDropdown') {
      navigate(PagesPaths.Settings);
    }
    if (e.value === 'signOut') {
      setConfirmLogOut(true);
    }
    return null;
  };

  return (
    <>
      {confirmLogOut && (
        <ConfirmDialog
          visible={confirmLogOut}
          onHide={() => setConfirmLogOut(false)}
          message={t('header:logutConfirmMessage')}
          header={t('profilePage:signOut')}
          accept={accept}
          reject={reject}
          acceptLabel={t('profilePage:signOut')}
          rejectLabel={t('signUp:buttonCancel')}
          style={{ width: '40vw' }}
          acceptClassName={styles.dangerButton}
          rejectClassName={styles.cancelButton}
          className={styles.signOutModalContent}
        />
      )}
      <header
        className={classNames(styles.header, isPrivate && styles.darkText)}
      >
        <div>
          {!isPrivate && (
            <Link to={PagesPaths.PublicHome}>
              <WhiteLogo />
            </Link>
          )}
        </div>
        <div>
          <nav>
            <ul>
              <li>
                <Link to={PagesPaths.CostSimulator}>
                  {t('header:costSimulator')}
                </Link>
              </li>
              <li>
                <Link to={PagesPaths.EIR}>{t('header:eir')}</Link>
              </li>
              {/* <li>
              <Link to={PagesPaths.OnlinePaymentInstructions}>
                {t('onlinePaymentInstructions')}
              </Link>
            </li> */}
            </ul>
          </nav>
          <Link
            to={PagesPaths.EInvoice}
            className={classNames(styles.button, isPrivate && styles.darkText)}
          >
            {t('header:eInvoice')}
          </Link>
          {!isAuthenticated() ? (
            <Link
              to={PagesPaths.Login}
              className={classNames(
                styles.button,
                styles.withDivider,
                isPrivate && styles.darkText
              )}
            >
              <FontAwesomeIcon icon={faCircleUser} className={styles.icon} />
              {t('header:login')}
            </Link>
          ) : (
            <div className={styles.user}>
              <div className={styles.icon}>
                <FontAwesomeIcon icon={faCircleUser} />
              </div>
              <DropdownField
                id="userDropdown"
                options={options}
                onChange={(e) => handleDropdownChange(e, 'userDropdown')}
                className="HeaderdropdownField"
                placeholder={userDataDecoded?.username}
                itemTemplate={optionTemplate}
              />
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
